const rules = {
  dateValid(field) {
    const dateRegEx = /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/;
    const [year, month, day] = field.split('-');

    return dateRegEx.test(`${month}/${day}/${year}`) || 'Invalid date - must be formatted MM/DD/YYYY';
  },
  decimal(scale, precision) {
    const regEx = new RegExp('^' + '[0-9]?'.repeat(scale - precision) + '(\\.' + '[0-9]?'.repeat(precision) + ')?$');

    return [v => (!v || regEx.test(v)) || 'Must be a decimal'];
  },
  emailValid: [
    v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.trim()) || 'Invalid email address'
  ],
  future: [v => new Date(v) > new Date() || 'Must be in the future'],
  maxLength(max) {
    return [v => (!v || `${v}`.length <= max) || `Must be ${max} characters or fewer`];
  },
  minLength(min) {
    return [v => (!v || `${v}`.length >= min) || `Must be at least ${min} characters`];
  },
  maxValue(max) {
    return [v => (!v || v <= max) || `Must be ${max} or less`];
  },
  numeric: [v => !v || /^[0-9]*$/.test(v) || 'Must be numeric'],
  required: [v => !!v || 'Required']
};

export { rules }
